import {DisplayType} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import {openPublishingOptionsModal} from '@Modals/publishing-options-modal/publishing-options-modal-library';
import {isUserPremium} from '@Libraries/user.library';
import {PublishingOptionsList} from '@Panels/poster-publishing-options-panel/components/publishing-options-default-list/publishing-options-default-list.types';
import {isMobile} from 'react-device-detect';
import {openUploadingImagesModal} from '@Modals/uploading-images-modal';

const openPublishingOptionsModalHelper = (idPosterHash: string, displayType: DisplayType): void => {
  openPublishingOptionsModal({
    panelDetails: {
      displayType: displayType,
    },
    isPosterMaker: window.PMW.isReactPosterMaker() ? 1 : 0,
    preselectPaidProduct: window.PMW.isEmbedded() && isUserPremium(),
    isPremium: window.posterEditor?.whiteboard?.getCurrentPage().isPremium() ? 1 : 0,
    posterType: window.posterEditor?.whiteboard?.type.name,
    idGalleryTemplate: window.posterEditor?.whiteboard?.getGalleryTemplateId(),
    idTemplate: window.posterEditor?.whiteboard?.getTemplateId(),
    idPosterHash,
    uc: window.posterEditor?.whiteboard?.savePoster.hasUnsavedChanges() ? 1 : 0,
    isVideo: window.posterEditor?.whiteboard?.isVideo() ? 1 : 0,
    hasVideoItem: window.posterEditor?.whiteboard?.getCurrentPage().items.hasVideoItem() ? 1 : 0,
    isExpensiveVideo: window.posterEditor?.whiteboard?.getCurrentPage().isExpensiveVideo() ? 1 : 0,
    isTransparent: window.posterEditor?.whiteboard?.getCurrentPage().isTransparent() ? 1 : 0,
    hasClickableLink: window.posterEditor?.whiteboard?.getCurrentPage().items.hasClickableItem() ? 1 : 0,
    pw: window.posterEditor?.whiteboard?.width,
    ph: window.posterEditor?.whiteboard?.height,
    ptw: window.posterEditor?.whiteboard?.userWidth,
    pth: window.posterEditor?.whiteboard?.userHeight,
    ptu: window.posterEditor?.whiteboard?.units,
    recommendedOptions: window.posterEditor?.whiteboard?.getCurrentPage().items.hasMenuItems()
      ? [PublishingOptionsList.WEB_LINK, PublishingOptionsList.DIGITAL_SIGNAGE, PublishingOptionsList.QR_CODE]
      : [],
  });
};
export const openNewPublishDialog = (hashedId: string | undefined): void => {
  const displayType = isMobile || !window.PMW.isReactPosterMaker() ? DisplayType.MODAL : DisplayType.DROPDOWN;
  const idPosterHash = hashedId || window?.posterEditor?.whiteboard?.hashedID || '';
  const poster = window.posterEditor?.whiteboard;
  if (poster) {
    const doesPosterHaveUploadingImages = poster.areAnyImagesUploading();
    const imageSrc = poster.getImageSrcOfUploadingImage();

    if (doesPosterHaveUploadingImages && imageSrc) {
      openUploadingImagesModal({
        title: window.i18next.t('pmwjs_uploading_images'),
        text: window.i18next.t('pmwjs_uploading_images_publishing_modal_description'),
        imgSrc: imageSrc,
      });
    } else {
      openPublishingOptionsModalHelper(idPosterHash, displayType);
    }
  } else {
    openPublishingOptionsModalHelper(idPosterHash, displayType);
  }
};
